/**
 * entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';
import { instance as getApi } from '@/helpers/api';
import dayjs from 'dayjs';

export class Image extends BaseModel {
    defaults() {
        return {
            id: null,
            title: null,
            staff_title: null,
            caption: null,
            credits: null,
            created: null,
            creator_id: null,
            album_id: null,
            relative_path: null,
            relative_thumb_path: null,
            orig_filename: null,
            width: null,
            height: null,
            mimetype: null,
            import_url: null,
            image_hash: null,
            animated: null,

            // virtual fields, calculated in backend:
            thumb_url: null,
            url: null,
        };
    }

    mutations() {
        return {
            id: Number,
            created: dayjs,
        };
    }

    entityName() {
        return 'image';
    }

    /**
     * Initiates the creation of a Featured Image, that is,
     * create the cropped versions of the given image for the
     * given record.
     *
     * This process creates images in the backend.
     *
     *
     * @param {String} entity The entity / type of the image to be created, e.g. 'magazin', 'event', 'address' etc.
     * @param {*} cropData The crop data object, containing x/y,width,height crop info
     * @param {*} record_id The id of the record to assign this cropped image to. This is the entity id.
     * @return
     */
    async createFeaturedImage(entity, cropData, record_id) {
        return await getApi().post('/image/createFeaturedImages', {
            image_id: this.id,
            record_id: record_id,
            type: entity,
            crop_data: cropData ? JSON.stringify(cropData) : null,
        });
    }
}

export class ImageCollection extends BaseCollection {
    options() {
        return {
            model: Image,
        };
    }

    entityName() {
        return 'image';
    }
}
